import React from "react";
import SectionHeader from "../Sections/SectionHeader";
import "./benefitsAgent.css";

interface BenefitItem {
  id: number;
  icon: React.ElementType;
  title: string;
  text: string;
}

interface BenefitsAgentProps {
  title?: string;
  subtitle?: string;
  tagline?: string;
  items?: BenefitItem[];
}

export default function BenefitsAgent({
  title,
  subtitle,
  tagline,
  items = [],
}: BenefitsAgentProps) {
  return (
    <section className="benefits-agent">
      {/* Header */}
      <SectionHeader title={title || ""} subtitle={subtitle || ""} />

      {/* Tagline */}
      {tagline && <p className="tagline">{tagline}</p>}

      {/* Benefits */}
      {items.length > 0 && (
        <div className="benefits-grid">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.id} className="benefit">
                <div className="icon-wrapper">
                  <Icon size={48} color="#0A0F1C" />
                </div>
                <h4 className="benefit-title">{item.title}</h4>
                <p className="benefit-text">{item.text}</p>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
